var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.503 4.627L5.5 6.75v10.504a3.25 3.25 0 003.25 3.25h8.616a2.25 2.25 0 01-2.122 1.5H8.75A4.75 4.75 0 014 17.254V6.75c0-.98.627-1.815 1.503-2.123zM17.75 2A2.25 2.25 0 0120 4.25v13a2.249 2.249 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25v-13A2.25 2.25 0 018.75 2h9zm0 1.5h-9a.75.75 0 00-.75.75v13c0 .414.336.75.75.75h9a.75.75 0 00.75-.75v-13a.75.75 0 00-.75-.75z",
    fill: "#333230"
  })));
}
export default SvgCopyNew;